import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import $ from 'jquery';
import {
    openMobilePlayerListing,
    setHighlight,
    makeCaptain,
    removePlayer,
    setTutorialCookie,
    triggerHandlePlayerCard
} from './../../actions/FormationActions';
import common from '../../common';
import config from "../../config";
import OutsideNotifier from '../../OutsideNotifier';

class Jersey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toShowCaptainInfo: false,
            selectedJersey: null,
            playerStatusIconClicked: false
        };
        this.timeout = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.player.id === null) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        }
        if (this.props.teamData.captainID === null && nextProps.teamData.captainID) {
            if (+this.props.player.id === +nextProps.teamData.captainID) {
                this.showCaptainTooltip();
            }
        }
    }

    onPlayerStatusIconClicked = (e, player) => {
        // e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        } else {
            this.setState({ selectedJersey: player.id, playerStatusIconClicked: true });
        }
    };
    onJerseyClick = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        common.customTracking('Tap on Player', '/uclfantasy/create-team/');
        if (this.state.playerStatusIconClicked) {
            this.setState({ playerStatusIconClicked: false });
        }
        if (player.id === null) {
            this.props.setHighlight({ player, objKey, playerIndex });
            if (config.isMobile) {
                this.props.openMobilePlayerListing(true);
            }
        } else {
            this.setState({ selectedJersey: player.id });
            this.onJerseyTapToAnimate(e);
        }
    };
    onFocusLost = () => {
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };
    onFocusLostCaptainTooltip = () => {
        this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
    };
    onInfoTap = (e, player, isDesktop) => {
        e.stopPropagation();
        if (isDesktop) {
            common.customTracking('Player Card');
        } else {
            // common.customTracking('Player Card - Tooltip');
        }
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        this.props.triggerHandlePlayerCard(true, player);
    };
    onMakeCaptainTap = (e, player, objKey, playerIndex, isCaptainScreen) => {
        e.stopPropagation();
        if (isCaptainScreen) {
            common.customTracking('Pick Captain', '/uclfantasy/create-team/');
        } else {
            common.customTracking('Captain Player - Tooltip');
        }
        this.setState({ toShowCaptainInfo: false });
        this.props.makeCaptain({ player, objKey, playerIndex });
    };
    showCaptainTooltip = () => {
        const hasSeenCaptainInfo = common.getLocalStorage('hasSeenCaptainInfo');
        if (!hasSeenCaptainInfo) {
            this.setState({ toShowCaptainInfo: true });
            common.setLocalStorage('hasSeenCaptainInfo', true);
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
            }, 3000);
        } else {
            this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
        }
    };

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
    }

    onRemoveTap = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        // common.customTracking('Remove Player - Tooltip');
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        if (common.isMobile()) {
            this.props.triggerHandlePlayerCard(true, player);
        } else {
            this.props.removePlayer({ player, objKey, playerIndex });
        }


    };
    animateView = (target) => {
        if (target.length === 0) return;
        const BUFFER = 30;
        const topValue = $(target).offset().top - $('.si-actions-strip-sticky').height() - ($('.si-actions-tooltip').outerHeight() || 0) - BUFFER;
        $('html,body').animate({
            scrollTop: topValue
        }, 500);
    };
    onJerseyTapToAnimate = (e) => {
        if (this.props.mobilePlayerListingOpen) {
            const tooltipElem = $(e.target).closest('.si-plyr-wrap');
            setTimeout(() => {
                (config.isMobile) && this.animateView(tooltipElem);
            }, 0);
        }
    };

    render() {
        const location = this.props.location;
        const isMobile = config.isMobile;
        const player = this.props.player;
        const { IsFixtureUpdated } = this.props.constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        const objKey = this.props.objKey;
        const isLast = this.props.position;
        const playerIndex = this.props.index;
        const isHighlighted = player.isHighlighted;
        const isCaptain = player.isCaptain;
        const selectedJersey = this.state.selectedJersey;
        const currentStep = getStep(location.pathname);
        const isPlayerSelected = selectedJersey === player.id;
        const showIconTooltip = isPlayerSelected && this.state.playerStatusIconClicked;
        const moreOptions = false && config.isMobile && selectedJersey && isPlayerSelected && !showIconTooltip;
        const captainTooltip = this.state.toShowCaptainInfo && isCaptain && this.props.location.pathname == "/create-team";
        const dataWrapClass = common.makeClasses({
            'si-data-wrap': true,
            'si-more-opts': isCaptain && this.state.toShowCaptainInfo && this.props.location.pathname == "/create-team"
        });
        const tutorialFirstTime = !this.props.hasSeenTutorial;
        // let showRemovePlayerIcon = isMobile && currentStep === 0;
        let showRemovePlayerIcon = currentStep === 0;
        const teamImg = config.playerImgBase + `player-jersey/${(player.details.Skill === 1) ? 'GK/' : ''}${player.details['TID']}.png`;
        const tutorialTooltip = <OutsideNotifier handler={ this.props.setTutorialCookie.bind(this) }>
            <div className="si-tooltip si-pick-tooltip">
                <span>{ this.props.trans['pick_your'] }</span>
            </div>
        </OutsideNotifier>;
        const jerseyClassName = common.makeClasses({
            'si-plyr-wrap': true,
            'si-current': config.isMobile ? (isHighlighted && this.props.mobilePlayerListingOpen) : isHighlighted,
            'si-tutorial': this.props.index == 0 && player.skill === 4 && tutorialFirstTime
        });
        let clickHandler = {};
        const isCreateTeamStep = currentStep === 0;
        const isChooseCaptainStep = currentStep === 1;
        if (isCreateTeamStep && tutorialFirstTime) {
            clickHandler = { onClick: this.props.setTutorialCookie.bind(this) };
        } else if (isCreateTeamStep) {
            if (config.isMobile) {
                if (player.id === null) {
                    clickHandler = { onClick: (e) => this.onJerseyClick(e, player, objKey, playerIndex) };
                } else {
                    clickHandler = { onClick: (e) => this.onInfoTap(e, player.details, true) };
                }


            } else {
                if (player.id === null) {
                    clickHandler = { onClick: (e) => this.onJerseyClick(e, player, objKey, playerIndex) };
                } else {
                    clickHandler = { onClick: (e) => this.onInfoTap(e, player.details, true) };
                }
            }
        } else if (isChooseCaptainStep) {
            clickHandler = { onClick: (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex, true) };
        }
        if (player.id === null) {
            return <div
                className={ jerseyClassName }
                { ...clickHandler }>
                <div className="si-data-wrap">
                    <span className="si-img-wrap" />
                    { (this.props.index == 0 && player.skill === 4 && tutorialFirstTime) ? tutorialTooltip : null }
                    <div className="si-plyr-pos">{ this.props.trans['short' + player.skill] }</div>
                    <div className="si-plyr-details">
                        <span className="si-plyr-name">TEST</span>
                        <span className="si-plyr-val">0m</span>
                    </div>
                </div>
            </div>
        } else {
            let pStatus = player.details.PStatus;
            let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
            let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
            let hasStatus = pStatusHeaderClass !== '' ? true : false;
            let playerStatusIcon = null;
            if (hasStatus) {
                let pStatusTransKey = pStatusObj[pStatus] ? pStatusObj[pStatus]["transKey"] : '';
                let jerseyClassObj = {
                    'si-active': showIconTooltip
                };
                jerseyClassObj[pStatusObj[pStatus]["playerJesreyClass"]] = true;
                jerseyClassObj[pStatusHeaderClass] = true;
                const jerseyStatusIconClass = common.makeClasses(jerseyClassObj);
                const iconTooltipClasses = common.makeClasses({
                    'si-tooltip': true,
                    'si-status-tooltip': true,
                    'si-left-tt': (playerIndex === 0),
                    'si-right-tt': (playerIndex === (this.props.numOfPlayers - 1)),
                });
                playerStatusIcon =
                    <div className={ jerseyStatusIconClass } onClick={ (e) => this.onPlayerStatusIconClicked(e, player) }>
                        <span className="si-status-icon">
                            <div className="si-tooltip si-status-tooltip si-left-tt">
                                <span>
                                    {
                                        this.props.trans[pStatusObj[pStatus]['toolTipTrans']] || pStatusObj[pStatus]['status']
                                    }
                                </span>
                            </div>
                        </span>
                        { showIconTooltip ? <OutsideNotifier handler={ () => this.onFocusLost() }>
                            <div className={ iconTooltipClasses }>
                                <span>{ this.props.trans[pStatusTransKey] }</span>
                            </div>
                        </OutsideNotifier> : null }
                    </div>
            }
            let captainMarkup = null;
            const captainClass = isCaptain ? 'si-captain-icon' : '';
            const tooltipClass = isLast && 'si-' + isLast + '-tt';
            if (!player.isBench && !isCaptain) {
                captainMarkup = <span
                    onClick={ (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex) }>{ this.props.trans['captain'] }</span>
            }
            let priceStrip = <div className="si-plyr-val">
                <span className="si-currency-font">€</span>
                <span>{ player.details.Value }{ this.props.trans.million }</span>
            </div>
            const UpComingMatchesList = player.details && player.details['UpComingMatchesList'] ? player.details['UpComingMatchesList'] : [];
            let vsObj = {};
            let vsTeam = '';
            if (UpComingMatchesList.length > 0) {
                vsObj = UpComingMatchesList[0];
            }
            if (vsObj.hasOwnProperty('VsCCode')) {
                vsTeam = vsObj['VsCCode'];
            }
            let vsStrip = <div className="si-plyr-val">
                <span>{ this.props.trans.vs_short } </span>
                <span className="si-vsStrip">{ vsTeam }</span>
            </div>
            let playerBottomStrip = null;
            if (currentStep === 1 || currentStep === 5) {
                playerBottomStrip = (isFixtureUpdated) ? vsStrip : priceStrip;
            } else {
                playerBottomStrip = priceStrip;
            }
            const jerseyClassName = common.makeClasses({
                'si-plyr-wrap': true,
                'si-selected': true,

            });
            return <div className={ jerseyClassName }
                { ...clickHandler } data-skill={ player.skill } data-id={ player.id } >
                <div className={ dataWrapClass }>
                    { playerStatusIcon }
                    <span className={ "si-img-wrap " + captainClass } style={ { backgroundImage: "url(" + teamImg + ")" } } >
                        {
                            (isCaptain)
                                ?
                                <i className="icon-ucl-captain si-captain" onClick={ (e) => { this.onInfoTap(e, player.details) } }>
                                    <div className="si-tooltip si-status-tooltip si-tt">
                                        <span>{ this.props.trans['captainTT'] || "Captain" }</span>
                                    </div>
                                </i>
                                :
                                null
                        }
                    </span>
                    { showRemovePlayerIcon ? <span className="si-icons si-no-tt"
                        onClick={ (e) => this.onRemoveTap(e, player.details, objKey, playerIndex) }><i
                            className="si-remove-player icon-ucl-close" />
                        {/* <div className="si-tooltip si-status-tooltip si-tt">
                            <span>{this.props.trans['transferOutTT'] || "Transfer Out"}</span>
                        </div> */}
                    </span> : null }
                    {/* {moreOptions ? <OutsideNotifier handler={() => this.onFocusLost()}>
                        <div className={"si-tooltip si-actions-tooltip " + tooltipClass + " si-flexBox"}>
                            <span onClick={(e) => this.onInfoTap(e, player.details)}>{this.props.trans.info}</span>
                            {captainMarkup}
                            <span
                                onClick={(e) => this.onRemoveTap(e, player.details, objKey, playerIndex)}>{this.props.trans.remove}</span>
                        </div>
                    </OutsideNotifier> : null} */}
                    { captainTooltip ?
                        <OutsideNotifier handler={ () => this.onFocusLostCaptainTooltip() }>
                            <div className={ "si-tooltip si-captain-tooltip si-flexBox " + tooltipClass }>
                                <span>{ this.props.trans['captain_will_get'] }</span></div>
                        </OutsideNotifier> : null }
                    <div className="si-plyr-pos">{ this.props.trans['short' + player.skill] }</div>
                    <div className="si-plyr-details">
                        <span className="si-plyr-name">{ player.details['PDName'] }</span>
                        { playerBottomStrip }
                    </div>
                </div>
            </div>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        hasSeenTutorial: state.formationData.hasSeenTutorial,
        teamData: state.formationData.teamData,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        setHighlight: (obj) => dispatch(setHighlight(obj)),
        makeCaptain: (obj, objKey, playerIndex) => dispatch(makeCaptain(obj, objKey, playerIndex)),
        removePlayer: (obj) => dispatch(removePlayer(obj)),
        setTutorialCookie: () => dispatch(setTutorialCookie()),
        triggerHandlePlayerCard: (isPlayerCardVisible, playerObj) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, playerObj)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Jersey));


// WEBPACK FOOTER //
// ./src/components/onboarding/Jersey.js